import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=6baf0c74&"
import script from "./Inquiries.vue?vue&type=script&lang=ts&"
export * from "./Inquiries.vue?vue&type=script&lang=ts&"
import style0 from "./Inquiries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
